import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import Avatar from '@/common/components/Avatar/Avatar';
import styles from './AssigneeSelectOption.module.less';
function AssigneeOption(props) {
    const { option } = props;
    const { label, description } = option.data;
    return (_jsxs("div", { className: styles.container, children: [_jsx(Avatar, { size: "large", username: label }), _jsxs("div", { className: styles.textContent, children: [_jsx("div", { className: styles.label, children: label }), description && _jsx("div", { className: styles.description, children: description })] })] }));
}
export default observer(AssigneeOption);
